import type { TGetEmpreendimentosResponse } from '@/http/get-empreendimentos.service'
import { HttpService } from '@/infra/http'
import type { TTipoEmpreendimento } from '@/types/empreendimento'
import type { TTipoProdutoChileEnum, TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'

export type TGetEmpreendimentosNovaSimulacaoResponse = Array<
  Omit<TGetEmpreendimentosResponse[number], 'empreendimentoFuturo' | 'imagem'>
>

export class GetEmpreendimentosNovaSimulacaoService extends HttpService {
  async execute(
    tipoDeEmpreendimento: TTipoEmpreendimento,
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum | TTipoProdutoChileEnum,
    idsExternosExcluidos: string[],
  ) {
    return this.http.get<TGetEmpreendimentosNovaSimulacaoResponse>(
      `api/v2/Empreendimento/novaSimulacao/${tipoDeEmpreendimento}/tipoDoProduto/${tipoDoProduto}`,
      {
        params: { idsExternosExcluidos },
        paramsSerializer: { indexes: true },
      },
    )
  }
}
